export default {
    SC: 'Santa Catarina',
    PR: 'Paraná',
    MS: 'Mato Grosso do Sul',
}